module.exports = __webpack_public_path__ + "static/media/CardCancellation.9d42b79e.png";